import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';

import * as ProgramTypes from '../../../state/reducer/calendar/programTypes';

import Console from '../../../lib/debug';

const MONTH_TYPES = [
    ProgramTypes.TYPES.TEAM,
    ProgramTypes.TYPES.COACH_ATHLETE_CALENDAR,
    ProgramTypes.TYPES.INVITED_ATHLETE_CALENDAR,
    ProgramTypes.TYPES.CALENDAR
];

export class DesignerHeaderClass extends Component {
    render() {
        Console.render('DesignerHeader');
        if (!this.props.designerHeader.enabled) return null;
        return (
            <div>
                <Toolbar>
                    <Typography
                        variant="title"
                        color="inherit"
                        className="flex"
                    />
                </Toolbar>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        designerHeader: state.nav.designerHeader,
        designerInfo: state.calendar.infoTree.designerInfo,
        programType: state.calendar.infoTree.programType,
        programId: state.calendar.infoTree.programId,
        athleteId: state.calendar.infoTree.athleteId,
        month: state.calendar.infoTree.month,
        year: state.calendar.infoTree.year,
        ...ownProps
    };
};

export default connect(mapStateToProps)(DesignerHeaderClass);
